import { PIXEL_EVENT } from 'constants/amethyst';

// order confirmation pixel
export const evPixelOrderEvent = ({ pageType, pageId, pageLang, pageTitle, trackingPayload = {} }) => ({
  [PIXEL_EVENT]: {
    page_type: pageType,
    page_id: pageId,
    page_lang: pageLang,
    page_title: pageTitle,
    order_confirmation_payload: trackingPayload
  }
});

// brand pixel
export const evPixelBrandEvent = ({ pageType, pageId, pageLang, pageTitle, trackingPayload = {} }) => ({
  [PIXEL_EVENT]: {
    page_type: pageType,
    page_id: pageId,
    page_lang: pageLang,
    page_title: pageTitle,
    brand_payload: trackingPayload
  }
});

// Helper function to safely extract product data
export const extractProductData = trackingPayload => {
  if (!trackingPayload?.product) {
    return {};
  }

  const { product } = trackingPayload;
  return {
    sku: product.sku,
    styleId: product.styleId,
    price: product.price,
    name: product.name,
    brand: product.brand,
    category: product.category,
    subCategory: product.subCategory,
    gender: product.gender
  };
};

// pdp pixel
export const evPixelPdpEvent = ({ pageType, pageId, pageLang, pageTitle, trackingPayload = {} }) => ({
  [PIXEL_EVENT]: {
    page_type: pageType,
    page_id: pageId,
    page_lang: pageLang,
    page_title: pageTitle,
    // The GTM event data has more fields than the amethyst event data must have. So we need to extract the product data before sending the Amethyst event.
    // https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/pixel/ProductDisplayPagePixelPayload.proto
    // https://code.amazon.com/packages/AmethystEvents/blobs/mainline/--/configuration/include/com/zappos/amethyst/pixel/PixelProduct.proto
    product_display_page_payload: {
      product: extractProductData(trackingPayload)
    }
  }
});

// search pixel
export const evPixelSearchEvent = ({ pageType, pageId, pageLang, pageTitle, trackingPayload = {} }) => ({
  [PIXEL_EVENT]: {
    page_type: pageType,
    page_id: pageId,
    page_lang: pageLang,
    page_title: pageTitle,
    search_payload: trackingPayload
  }
});

// cart pixel
export const evPixelCartEvent = ({ pageType, pageId, pageLang, pageTitle, trackingPayload = {} }) => ({
  [PIXEL_EVENT]: {
    page_type: pageType,
    page_id: pageId,
    page_lang: pageLang,
    page_title: pageTitle,
    cart_payload: trackingPayload
  }
});

// default pixel event with no payload
export const evPixelEvent = ({ pageType, pageId, pageLang, pageTitle }) => ({
  [PIXEL_EVENT]: {
    page_type: pageType,
    page_id: pageId,
    page_lang: pageLang,
    page_title: pageTitle
  }
});
